module.exports = __webpack_public_path__ + "img/orng_5.771609f1.jpg";